// @flow weak

import {
  TOGGLE_DIALOG,
} from '../actions/actionConfirmation';

const actionConfirmation = (state = {}, action) => {
  switch (action.type) {
    case TOGGLE_DIALOG:
      return {
        ...state,
        [action.id]: !!action.show,
      };
    default:
      return state;
  }
};

export default actionConfirmation;



// WEBPACK FOOTER //
// ./src/reducers/actionConfirmation.js